/** @jsx jsx */
import { jsx, Flex } from 'theme-ui'
import { BrandLogoDesktop } from '../../icons/index'
import footerBackground from './footer-background.png'

const EmptyFooter = () => {
  return (
    <Flex
      sx={{
        display: 'flex',
        flexDirection: 'column',
        bg: 'forest',
        backgroundImage: `url(${footerBackground})`,
        backgroundSize: 'cover',
        py: 7,
        px: [4, 4, 8],
      }}
    >
      <BrandLogoDesktop />
    </Flex>
  )
}

export default EmptyFooter
